import { cwslapi } from "../index";

// 获取验证码图片
export const getCaptcha = (data) => {
  return cwslapi({
    url: "/login/getCaptcha",
    method: "get",
    xhrFields: {
      withCredentials: true,
    },
    responseType: "arraybuffer",
  });
};

// 登录
export const getdoLogin = (data) => {
  return cwslapi({
    url: "/login/doLogin",
    method: "post",
    data,
  });
};

//  获取用户信息
export const getMemberInfo = (data) => {
  return cwslapi({
    url: "/user/getMemberInfo",
    method: "post",
    data,
  });
};


//  找回密码 —— 用户管理
export const getfindPwd = (data) => {
  return cwslapi({
    url: "/user/findPwd",
    method: "post",
    data,
  });
};